@use "@fukuri-admins/ui/layout" as *;

$Primary: #21e4a3;

.displayNone {
  display: none;
}

.modalRoot {
  padding: 56px 24px 64px;
  box-sizing: border-box;
  width: 100%;
  max-width: 650px;
  height: fit-content;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(55, 55, 79, 0.05);
  border-radius: 10px;
  text-align: center;
  margin: auto;
  @media (max-width: 769px) {
    min-width: 100% !important;
    width: 100% !important;
  }
}

.form {
  text-align: left;
  max-width: 400px;
  margin: 0 auto 20px;
  &.formName {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.formTitle {
  color: $TextInput;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 8px;
  @media (max-width: 440px) {
    font-size: 12px;
  }
}

.symbol {
  color: $Primary;
  font-family: "Noto Sans JP"; //20230111
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  margin-right: 5px;
}

.formInput {
  padding: 8px;
  color: $TextInput;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}

.loaderWrapper {
  position: fixed;
  z-index: 99998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: scroll;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  color: $Text;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  margin-bottom: 8px;
}

.mainContainer {
  padding: 0px 50px;
  @media (max-width: 540px) {
    padding: 0;
  }
}

.descContainer {
  color: $TextLight;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  margin-bottom: 32px;
}

.btnContainer {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  @media (max-width: 570px) {
    display: block;
  }
}

.cancelBtn {
}

.confirmBtn {
}

.name {
  display: flex;
  align-items: center;
}

.formMiddle {
}

.formShort {
}

.marginRight24 {
  margin-right: 24px;
}

.errorMessage {
  color: red;
  font-family: "Noto Sans JP"; //20230111
  font-weight: 800;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
